import React from 'react';
import { withTranslation } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import { enumText, translate, isNullOrEmpty, getUserNameToName, formatData, enumColor } from '../../../../../utils/util';
import { ENUMS, PERMISSIONS } from '../../../../../utils/constants';
import { checkPermission } from '../../../../../services/auth';
import { connect } from 'react-redux';
import { getVision } from '../../../../../services/auth';
import { VISIONS } from '../../../../../utils/constants';

const LinePickingListItemOrder = (props) => {
    const manageOrder = checkPermission(PERMISSIONS.Lowering.Access);
    const getStatus = (value) => translate(`expedition:${enumText(ENUMS.eOrderStatus, value)}`);


    const getSupplierName = (text) => {
        if (!isNullOrEmpty(text)) {
            const supplier = text.trim().split(/\s+/);
            return supplier.slice(0, 2).join(' ');
        }
        else {
            return text;
        }
    };



    const renderItems = () => {
        return (<>

            <div
                className="row"
                style={{ display: 'block', margin: '5px' }}
            >
                {!isNullOrEmpty(props.data?.pabOrderCode) &&
                    <div className="col s10 " style={{ padding: '0px' }}>
                        <span className="title sixth-text-color"> {`TD : ${props.data?.pabOrderCode || ""}`}</span>
                    </div>
                }
                <div className="col s10 " style={{ padding: '0px' }}>
                    <span className="title sixth-text-color">{`${translate('stock:partnumber')} : ${props.data?.partNumberCode || ""}`}</span>
                </div>
                <div className="col s10">
                    <span className="truncate second-text-color">{`${translate('stock:description')} : ${props.data?.partNumberDescription || ""}`} </span>
                </div>
                {!isNullOrEmpty(props.data?.supplierCode) &&
                    <div className="col s12 ">
                        <span className="truncate second-text-color"> {`${translate('expedition:picking.supplier')} : ${props.data?.supplierCode || ""}-${getSupplierName(props.data?.supplierName) || ""}`}</span>
                    </div>
                }
                {!isNullOrEmpty(props.data?.mdr) &&
                    <div className="col s12">
                        <span className="truncate second-text-color">{`${translate('change-location:mdr')} : ${props.data?.mdr || ""}`} </span>
                    </div>
                }
                <div className="col s12">
                    <span className="truncate second-text-color"> {`${translate('stock:location')} : ${props.data?.location || props.data?.locationTarget}`} </span>
                </div>
                {props.data?.createdOn &&
                    <div className="col s10">
                        <span className="truncate second-text-color"> {`${translate('physical-confirmation:date')} ${translate('expedition:picking.order')}: ${formatData(props.data?.createdOn) || ""}`} </span>
                    </div>
                }

                <div className="col s12">
                    <span className="truncate second-text-color">  {`${translate('stock:quantity')} TD : ${props.data?.quantity || ""}`}</span>
                </div>
                {!isNullOrEmpty(props.data?.status) &&
                    <div className="col s12">
                        <span className="truncate second-text-color"> {`${translate('general:status')} : ${getStatus(props.data?.status) || ""}`} </span>
                    </div>
                }
            </div>
        </>)
    }

    return (
        <>
            {
                !props.report ? (
                    <Link
                        className="row"
                        style={{ display: 'block', marginBottom: '0px' }}
                        to={props.route}
                        onClick={(event) => {
                            if (props.onSelectChange && !props.report) {
                                props.onSelectChange(event);
                            }
                        }} >
                        {renderItems()}
                    </Link>) : (
                    <div
                        className="row"
                        style={{ display: 'block', marginBottom: '0px' }}>
                        {renderItems()}
                    </div>
                )
            }
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        filter: state.pabReplanningReducer.filter,
        usersFromElog: state.usersElogReducer.usersElog,
        user: state.userReducer.user
    };
};

export default withRouter(connect(mapStateToProps)(withTranslation()(LinePickingListItemOrder)));
